<template>
  <div class="relative flex">
    <div class="mr-[16px] hidden self-center text-button font-semibold text-gpx_black-500 sm:block">
      <span>{{ label }}:</span>
    </div>

    <button class="flex rounded-[4px] bg-bg-1" @click="showDropdown = true">
      <span
        class="px-[24px] py-[11px] text-xs font-medium text-gpx_gray-200"
        :class="{ 'text-gpx_black-300': modelValue }"
        >{{ modelValue ? smartUpperFirst(modelValue) : upperFirst(type) }}</span
      >
      <span v-if="!modelValue" class="border-l border-l-white px-[10px] py-[11px]">
        <ChevronDownIcon class="heroicon-stroke-w-1.2 h-[18px] w-[18px] text-gpx_gray-300" />
      </span>
      <span
        v-if="modelValue"
        @click.stop="$emit('update:modelValue', null)"
        class="border-l border-l-white px-[10px] py-[11px]"
      >
        <XMarkIcon class="heroicon-stroke-w-1.2 h-[18px] w-[18px] text-gpx_gray-300" />
      </span>
    </button>
    <div
      v-if="showDropdown"
      class="absolute right-0 top-full z-30 min-w-[160px] translate-y-[8px] rounded-[6px] border border-gpx_gray-900 bg-white text-xs text-gpx_black-300 drop-shadow-main"
      :class="dropDownClass"
      v-click-outside="hideDropdown"
    >
      <div
        v-for="option in options"
        :key="option.name"
        @click.stop="setValue(option.name)"
        class="flex cursor-pointer items-center gap-x-[10px] border-b border-b-gpx_gray-900 px-[20px] py-[8px] font-medium last-of-type:border-b-0 hover:bg-gpx_gray-900"
      >
        <div class="h-[8px] w-[8px] rounded-full" :class="getIndicatorColor(option.name)"></div>
        {{ smartUpperFirst(option.name) }}
      </div>
    </div>
  </div>
</template>

<script>
import * as _ from 'lodash'
import vClickOutside from 'click-outside-vue3'
import { ChevronDownIcon, XMarkIcon } from '@heroicons/vue/24/outline'
import { statusColorMap } from '@gpx-spa/constants'

export default {
  components: {
    ChevronDownIcon,
    XMarkIcon
  },
  directives: {
    clickOutside: vClickOutside.directive
  },

  emits: ['update:modelValue'],

  props: {
    label: {
      required: false,
      type: String,
      default: 'Filter by'
    },
    filter: Object,
    type: String,
    modelValue: [String, Boolean],
    options: Array,
    dropDownClass: String,
    capitalize: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      showDropdown: false
    }
  },

  methods: {
    upperFirst: _.upperFirst,
    setValue(value) {
      this.$emit('update:modelValue', value)
      this.hideDropdown()
    },
    getIndicatorColor(status) {
      const color = statusColorMap[status]
      switch (color) {
        case 'red':
          return 'bg-gpx_red-200'
        case 'blue':
          return 'bg-gpx_blue-200'
        case 'yellow':
          return 'bg-gpx_yellow-200'
        case 'green':
          return 'bg-gpx_green-200'
        case 'porto':
          return 'bg-gpx_porto-200'
        case 'gray':
          return 'bg-gpx_gray-200'
        default:
          return ''
      }
    },
    smartUpperFirst(value) {
      if (this.capitalize) {
        return value.split('-').map(this.upperFirst).join(' ')
      }
      return value
    },
    hideDropdown() {
      this.showDropdown = false
    }
  }
}
</script>
